import * as Styled from './ProgressSquares.styles';

type Props = {
  progress: number;
};

const ProgressSquares = ({ progress = 0 }: Props) => (
  <Styled.ProgressWrapper>
    <Styled.ProgressSquares $progress={progress} />
    <Styled.Text>{progress}%</Styled.Text>
  </Styled.ProgressWrapper>
);

export default ProgressSquares;
